export  enum ApiQueryEnum {
    NORMATIVOS = "normativos?q=",
    NORMATIVOS_QUERY = "normativos/query?q=",
    DOWNLOAD_RESULTADO = "normativos/download/?q=",
    TIPOS_NORMATIVOS = "/tipos-normativos",
    NORMATIVO ="/normativo?id=",
    APRESENTACAO = "/normativo/apresentacao/",
    APRESENTACAO_CONSOLIDADO = "/normativo/apresentacao/consolidado/",
    NORMATIVO_DESTAQUES = "/normativos/destaques",
    NORMATIVO_RECENTES = "/normativos/ultimos-registros",
}
export default ApiQueryEnum;